import { render, staticRenderFns } from "./WebFamousPediaBottomBar.vue?vue&type=template&id=68ee6c0e&"
import script from "./WebFamousPediaBottomBar.vue?vue&type=script&lang=js&"
export * from "./WebFamousPediaBottomBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports